import { render } from "./QrScanner.vue?vue&type=template&id=175b83dc&lang=pug"
import script from "./QrScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./QrScanner.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__